import { observer } from 'mobx-react-lite';
import { Avatar, Group, Skeleton, Text } from '@mantine/core';
import { useClient } from '@/queries/clients/useClient';
import { getClientImageUrl } from '@/utils/file';

const SIZES_MAP = {
  xs: {
    iconSize: 14,
    textSize: 'xs',
  },
  sm: {
    iconSize: 16,
    textSize: 'sm',
  },
  md: {
    iconSize: 20,
    textSize: 'md',
  },
};

type ClientBadgeSize = keyof typeof SIZES_MAP;

export const ClientBadge = observer(
  ({ clientId, size = 'sm' }: { clientId: string; size?: ClientBadgeSize }) => {
    const { iconSize, textSize } = SIZES_MAP[size];

    const { data: client } = useClient(clientId);

    if (!client) {
      return (
        <Group gap="2xs" align="baseline" wrap="nowrap">
          <Skeleton circle w={iconSize} h={iconSize} />
          <Skeleton w={100} h={iconSize} />
        </Group>
      );
    }

    return (
      <Group gap="2xs" align="center" wrap="nowrap">
        <Avatar
          size={iconSize}
          radius="lg"
          src={client.image ? getClientImageUrl(client.id) : undefined}
          name={client.name}
          color="initials"
        />
        <Text size={textSize} fw={500}>
          {client.name}
        </Text>
      </Group>
    );
  }
);
